const babyAiTranslation = {
  mode: 'en',
  babyAiMenu: 'Manage BabyView AI',

  babyAiListTitle: 'Manage BabyView AI',

  seq: 'Seq',
  hospital: 'Account',
  hospitalRoom: 'Location',
  barcode: 'Barcode',
  userSeq: 'User Seq',
  babySeq: 'Baby Seq',
  createTime: 'Capture Time',
  aiImage: 'AI Image',
  captureImage: 'Capture Image',
  hiddenBabyImage: 'Hidden Baby Image',
  babyMagicImage: 'BabyView AI Image',
  visibleFlag: 'Visible?',
  manage: 'Manage',
  webhookSentAt: 'Webhook Sent Time',
  send: 'Send',

  public: 'Public',
  private: 'Private',
  manual: 'Resend',
  noBabyMagic: 'No BabyView AI Image',

  searchBarcode: 'Search Barcode',

  visibleFlagInactiveMessage: 'Make this item private?',
  visibleFlagActiveMessage: 'Make this item public?',

  // Baby Magic creation related
  createBabyMagic: 'Create BabyView AI',
  babyMagicCreateSuccess: 'BabyView AI creation completed successfully.',
  title: 'Title',
  enterTitle: 'Enter title',
  ethnicity: 'Ethnicity',
  skinTone: 'Skin Tone',
  selectCapture: 'Select Capture Image',
  selectCaptureRequired: 'Please select a capture image.',
  selectBabyRequired: 'Please select a baby.',

  // UI Text
  videoInfo: 'Video Information',
  recordingNumber: 'Recording Number',
  userInfo: 'User Information',
  loadingUserInfo: 'Loading user information...',
  userNumber: 'User Number',
  fullName: 'Full Name',
  noName: 'No Name',
  phoneNumber: 'Phone Number',
  babyInfo: 'Baby Information',
  babyNumber: 'Baby Number',
  babyNickname: 'Baby Nickname',
  twins: 'Twins',
  noBabyInfo: 'No registered baby information',
  noRegisteredBaby: 'No baby registered with this barcode.',
  captureNumber: 'Capture Number',
  viewLarge: 'View Large',
  selectionRequired: 'Baby number and ultrasound capture selection required',
};

export default babyAiTranslation;
